import { render } from "./TopBarWhiteBackground.vue?vue&type=template&id=6ddadeb8&scoped=true"
import script from "./TopBarWhiteBackground.vue?vue&type=script&lang=js"
export * from "./TopBarWhiteBackground.vue?vue&type=script&lang=js"

import "./TopBarWhiteBackground.vue?vue&type=style&index=0&id=6ddadeb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddadeb8"]])

export default __exports__